import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { OptionGroup } from '@core/interfaces/option-group';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import OptionGroupForm from '@core/components/forms/option-group-form/option-group-form.vue';

@Component({
  name: 'bpc-option-group-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': BpcDrawerModal,
    'bpc-option-group-form': OptionGroupForm,
  },
})
export default class OptionGroupTable extends mixins(AbstractTable) {
  @Prop(Boolean) showDrawerLarge: boolean;
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: OptionGroup = null;
  public entityName = 'option-group';
  public pluralEntityName = 'option-groups';
  public showDrawerSettingSection: boolean = false;
  public permissionEntityNameToUse = 'option_groups';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  setEntityAttributesAfterSave() {
    this.entity.name = null;
    this.entity.entity_type = null;
    this.entity.options = null;
  }
}
